// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Nexa-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Nexa-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cormorant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cormorant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Cormorant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Cormorant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Cormorant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Bruney.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/GeneralSans-Extralight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/GeneralSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/images/Image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/images/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-style: normal;
  font-weight: 700;
}
@font-face {
  font-family: "Bruney";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-style: normal;
  font-weight: 700;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

body {
  font-family: GeneralSans, sans-serif;
}

.mainparent {
  display: flex;
  flex-direction: column;
  background-color: #2f020c;
  padding-bottom: 2rem;
}

.contact__image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  height: 25vh;
  aspect-ratio: 16/9;
  margin-top: 2.5rem;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position-x: 0%;
  background-position-y: -2.5rem;
  background-attachment: fixed;
}
.contact__parent {
  margin-top: 4rem;
  display: flex;
}
.contact__child1 {
  margin-top: 2rem;
  margin: auto;
}
.contact__formtitle {
  color: white;
  font-size: 1.2rem;
  font-weight: 600;
  text-align: center;
  padding-bottom: 1rem;
}
@media (min-width: 768px) {
  .contact__formtitle {
    padding-top: 2rem;
    padding-bottom: 1.6rem;
    font-size: 2rem;
    font-weight: 400;
  }
}
.contact__form {
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: auto;
  max-width: 400px;
}
@media (min-width: 768px) {
  .contact__form {
    width: 90%;
  }
}
.contact__form--parent {
  display: flex;
  flex-direction: row;
}
.contact__form--name, .contact__form--email, .contact__form--phone, .contact__form--city {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 1rem;
  margin-bottom: 0.5rem;
  border-radius: 6px;
  border: none;
  font-family: Nexa;
  font-weight: 400;
  background-color: rgb(235, 234, 234);
}
@media (min-width: 768px) {
  .contact__form--name, .contact__form--email, .contact__form--phone, .contact__form--city {
    height: 6vh;
    font-size: 1rem;
  }
}
.contact__form--name {
  margin-right: 0.5rem;
}
.contact__form--name, .contact__form--city {
  width: 50%;
}
.contact__form--message {
  padding-top: 0.25rem;
  padding-bottom: 4rem;
  padding-left: 1rem;
  margin-bottom: 0.5rem;
  border-radius: 6px;
  border: none;
  font-family: Nexa;
  font-weight: 400;
  color: gray;
  background-color: rgb(235, 234, 234);
}
@media (min-width: 768px) {
  .contact__form--message {
    padding-top: 1rem;
    font-size: 1rem;
  }
}
.contact__form--button {
  font-family: Nexa;
  font-weight: 600;
  margin-top: 0.1rem;
  border-radius: 6px;
  height: 5vh;
  width: 100%;
  background-color: rgb(181, 144, 88);
  color: rgb(44, 43, 43);
}
@media (min-width: 768px) {
  .contact__form--button {
    height: 5vh;
    font-size: 1.1rem;
  }
}

.contactinfo__parent {
  width: 100%;
}
.contactinfo__container1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  padding: 0;
  margin: auto;
}
@media (min-width: 768px) {
  .contactinfo__container1 {
    margin-top: 2rem;
    height: 35vh;
  }
}
.contactinfo__emailparent {
  padding-left: 2.2rem;
}
.contactinfo__phoneparent, .contactinfo__emailparent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.contactinfo__phoneparent--text, .contactinfo__emailparent--text {
  padding-bottom: 1rem;
}
.contactinfo__title {
  color: white;
  font-size: 1.3rem;
  font-weight: 600;
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
@media (min-width: 768px) {
  .contactinfo__title {
    font-size: 1.8rem;
    font-weight: 400;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}
.contactinfo__phone, .contactinfo__email {
  color: white;
  font-size: 1rem;
  font-weight: 400;
  text-shadow: 2px 2px 4px black;
}
@media (min-width: 768px) {
  .contactinfo__phone, .contactinfo__email {
    font-size: 1.2rem;
  }
}
.contactinfo__email {
  margin-bottom: 1rem;
}
.contactinfo__icon {
  align-self: baseline;
}
.contactinfo__icon, .contactinfo__icon--insta {
  width: 1.3rem;
  height: 1.3rem;
  margin-right: 0.5rem;
}
@media (min-width: 768px) {
  .contactinfo__icon, .contactinfo__icon--insta {
    width: 2rem;
    height: 2rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
}
.contactinfo__icon--insta {
  margin-right: 1rem;
  margin-top: 0.5rem;
}
.contactinfo__logo {
  width: 60%;
  display: block;
  margin: auto;
}
@media (min-width: 400px) {
  .contactinfo__logo {
    padding-left: 1rem;
    width: 10rem;
  }
}
@media (min-width: 768px) {
  .contactinfo__logo {
    width: 13rem;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
}
.contactinfo__operationhours--title {
  padding-top: 2rem;
  padding-bottom: 1rem;
  text-align: center;
  font-size: 1.2rem;
  color: white;
}
@media (min-width: 768px) {
  .contactinfo__operationhours--title {
    font-weight: 400;
    font-size: 1.8rem;
    padding-top: 3rem;
    padding-bottom: 2rem;
  }
}
.contactinfo__operationhours--text {
  color: white;
  text-align: center;
  font-size: 1rem;
  padding-bottom: 1rem;
  line-height: 1.5rem;
}
@media (min-width: 768px) {
  .contactinfo__operationhours--text {
    font-size: 1.2rem;
    padding-bottom: 1.5rem;
  }
}
.contactinfo__copyright {
  color: white;
  font-size: 0.8rem;
  padding-top: 1rem;
  padding-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/partials/_typography.scss","webpack://./src/pages/ContactPage/ContactPage.scss","webpack://./src/styles/partials/_global.scss","webpack://./src/styles/partials/_variables.scss","webpack://./src/styles/partials/_mixins.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ACzEA;;;EAGI,sBAAA;EACA,SAAA;AD2EJ;;ACzEA;EACI,oCAAA;AD4EJ;;AAlFA;EACI,aAAA;EACA,sBAAA;EACA,yBEGc;EFFd,oBAAA;AAqFJ;;AAlFI;EACI,0DAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;AAqFR;AAnFI;EACI,gBAAA;EACA,aAAA;AAqFR;AAnFI;EACI,gBAAA;EACA,YAAA;AAqFR;AAnFI;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAqFR;AGtHI;EH4BA;IAOQ,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,gBAAA;EAuFV;AACF;AArFI;EACI,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAuFR;AGtII;EHyCA;IAQQ,UAAA;EAyFV;AACF;AAxFQ;EACI,aAAA;EACA,mBAAA;AA0FZ;AAxFQ;EACI,oBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;AA0FZ;AG1JI;EHuDI;IAWQ,WAAA;IACA,eAAA;EA4Fd;AACF;AA1FQ;EACI,oBAAA;AA4FZ;AA1FQ;EACI,UAAA;AA4FZ;AA1FQ;EACI,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AA4FZ;AGlLI;EH4EI;IAYQ,iBAAA;IACA,eAAA;EA8Fd;AACF;AA5FQ;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mCAAA;EACA,sBE7FO;AF2LnB;AGlMI;EH4FI;IAUQ,WAAA;IACA,iBAAA;EAgGd;AACF;;AA3FI;EACI,WAAA;AA8FR;AA5FI;EACI,0DAAA;EACA,UAAA;EACA,YAAA;AA8FR;AGjNI;EHgHA;IAKQ,gBAAA;IACA,YAAA;EAgGV;AACF;AA9FI;EACI,oBAAA;AAgGR;AA9FI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAgGR;AA/FQ;EACI,oBAAA;AAiGZ;AA9FI;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AAgGR;AG3OI;EHqIA;IAQQ,iBAAA;IACA,gBAAA;IACA,iBAAA;IACA,oBAAA;EAkGV;AACF;AAhGI;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;AAkGR;AGzPI;EHmJA;IAMQ,iBAAA;EAoGV;AACF;AAlGI;EACI,mBAAA;AAoGR;AAlGI;EACI,oBAAA;AAoGR;AAlGI;EACI,aAAA;EACA,cAAA;EACA,oBAAA;AAoGR;AGzQI;EHkKA;IAKQ,WAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;EAsGV;AACF;AApGI;EACI,kBAAA;EACA,kBAAA;AAsGR;AApGI;EACI,UAAA;EACA,cAAA;EACA,YAAA;AAsGR;AArGQ;EAJJ;IAKQ,kBAAA;IACA,YAAA;EAwGV;AACF;AGhSI;EHiLA;IASQ,YAAA;IACA,mBAAA;IACA,sBAAA;EA0GV;AACF;AAvGQ;EACI,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AAyGZ;AG9SI;EHgMI;IAOQ,gBAAA;IACA,iBAAA;IACA,iBAAA;IACA,oBAAA;EA2Gd;AACF;AAzGQ;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AA2GZ;AG7TI;EH6MI;IAOQ,iBAAA;IACA,sBAAA;EA6Gd;AACF;AA1GI;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AA4GR","sourcesContent":["@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Bold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Light.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Regular.ttf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Medium.ttf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-SemiBold.ttf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Bold.ttf);\n    font-style: normal;\n    font-weight: 700;\n}\n@font-face{\n    font-family: \"Bruney\";\n    src: url(../../assets/fonts/Bruney.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Extralight.otf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Regular.otf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Semibold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Bold.otf);\n    font-style: normal;\n    font-weight: 700;\n}\n","@use \"../../styles/partials/variables\" as *;\n@use \"../../styles/partials/typography\" as *;\n@use \"../../styles/partials/mixins\" as *;\n@use \"../../styles/partials/_global\" as *;\n\n.mainparent{\n    display: flex;\n    flex-direction: column;\n    background-color: $xeus-darkmaroon;\n    padding-bottom: 2rem;\n}\n.contact{\n    &__image{\n        background-image: url('../../assets/images/Image.png');\n        height: 25vh;\n        aspect-ratio: 16/9;\n        margin-top: 2.5rem;\n        background-size: 100%;\n        background-repeat: no-repeat;\n        background-position-x: 0%;\n        background-position-y: -2.5rem;\n        background-attachment: fixed;\n    }\n    &__parent{\n        margin-top: 4rem;\n        display: flex;\n    }\n    &__child1{\n        margin-top: 2rem;\n        margin: auto;\n    }\n    &__formtitle{\n        color: white;\n        font-size: 1.2rem;\n        font-weight: 600;\n        text-align: center;\n        padding-bottom: 1rem;\n        @include tablet-and-desktop{\n            padding-top: 2rem;\n            padding-bottom: 1.6rem;\n            font-size: 2rem;\n            font-weight: 400;\n        }\n    }\n    &__form{\n        padding-bottom: 2rem;\n        display: flex;\n        flex-direction: column;\n        width: 80%;\n        margin: auto;\n        max-width: 400px;\n        @include tablet-and-desktop{\n            width: 90%;\n        }\n        &--parent{\n            display: flex;\n            flex-direction: row;\n        }\n        &--name, &--email, &--phone, &--city {\n            padding-top: 0.25rem;\n            padding-bottom: 0.25rem;\n            padding-left: 1rem;\n            margin-bottom: 0.5rem;\n            border-radius: 6px;\n            border: none;\n            font-family: Nexa;\n            font-weight: 400;\n            background-color: rgb(235, 234, 234);\n            @include tablet-and-desktop{\n                height: 6vh;\n                font-size: 1rem;\n            }\n        }\n        &--name{\n            margin-right: 0.5rem;\n        }\n        &--name, &--city {\n            width: 50%;\n        }\n        &--message{\n            padding-top: 0.25rem;\n            padding-bottom: 4rem;\n            padding-left: 1rem;\n            margin-bottom: 0.5rem;\n            border-radius: 6px;\n            border: none;\n            font-family: Nexa;\n            font-weight: 400;\n            color: gray;\n            background-color: rgb(235, 234, 234);\n            @include tablet-and-desktop{\n                padding-top: 1rem;\n                font-size: 1rem;\n            }\n        }\n        &--button{\n            font-family: Nexa;\n            font-weight: 600;\n            margin-top: 0.1rem;\n            border-radius: 6px;\n            height: 5vh;\n            width: 100%;\n            background-color: rgb(181, 144, 88);\n            color: $website-darkgray;\n            @include tablet-and-desktop{\n                height: 5vh;\n                font-size: 1.1rem;\n            }\n        }\n    }\n}\n.contactinfo{\n    &__parent{\n        width: 100%;\n    }\n    &__container1{\n        background-image: url('../../assets/images/background.jpg');\n        padding: 0;\n        margin: auto;\n        @include tablet-and-desktop{\n            margin-top: 2rem;\n            height: 35vh;\n        }\n    }\n    &__emailparent{\n        padding-left: 2.2rem;\n    }\n    &__phoneparent, &__emailparent{\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n        &--text{\n            padding-bottom: 1rem;\n        }\n    }\n    &__title{\n        color: white;\n        font-size: 1.3rem;\n        font-weight: 600;\n        text-align: center;\n        padding-top: 1rem;\n        padding-bottom: 1rem;\n        @include tablet-and-desktop{\n            font-size: 1.8rem;\n            font-weight: 400;\n            padding-top: 2rem;\n            padding-bottom: 2rem;\n        }\n    }\n    &__phone, &__email{\n        color: white;\n        font-size: 1rem;\n        font-weight: 400;\n        text-shadow:  2px 2px 4px black;\n        @include tablet-and-desktop{\n            font-size: 1.2rem;\n        }\n    }\n    &__email{\n        margin-bottom: 1rem;\n    }\n    &__icon{\n        align-self: baseline;\n    }\n    &__icon, &__icon--insta{\n        width: 1.3rem;\n        height: 1.3rem;\n        margin-right: 0.5rem;\n        @include tablet-and-desktop{\n            width: 2rem;\n            height: 2rem;\n            margin-right: 1rem;\n            margin-bottom: 1rem;\n        }\n    }\n    &__icon--insta{\n        margin-right: 1rem;\n        margin-top: 0.5rem;\n    }\n    &__logo{\n        width: 60%;\n        display: block;\n        margin: auto;\n        @media (min-width: 400px) {\n            padding-left: 1rem;\n            width: 10rem;       \n        }\n        @include tablet-and-desktop{\n            width: 13rem;\n            padding-top: 1.5rem;\n            padding-bottom: 1.5rem;\n        }\n    }\n    &__operationhours{\n        &--title{\n            padding-top: 2rem;\n            padding-bottom: 1rem;\n            text-align: center;\n            font-size: 1.2rem;\n            color: white;\n            @include tablet-and-desktop{\n                font-weight: 400;\n                font-size: 1.8rem;\n                padding-top: 3rem;\n                padding-bottom: 2rem;\n            }\n        }\n        &--text{\n            color: white;\n            text-align: center;\n            font-size: 1rem;\n            padding-bottom: 1rem;\n            line-height: 1.5rem;\n            @include tablet-and-desktop{\n                font-size: 1.2rem;\n                padding-bottom: 1.5rem;\n            }\n        }\n    }\n    &__copyright{\n        color: white;\n        font-size: 0.8rem;\n        padding-top: 1rem;\n        padding-left: 1rem;\n    }\n}","@use \"./variables\" as *;\n@use \"./typography\" as *;\n@use \"./mixins\" as *;\n\n*,\n*::before,\n*::after{\n    box-sizing: border-box;\n    margin: 0;\n}\nbody{\n    font-family: GeneralSans, sans-serif;\n}\n","$tablet-breakpoint: 768px;\n$desktop-breakpoint: 1280px;\n$max-width: 1195px;\n$mobile-header-fontsize: 1rem;\n$mobile-subheader-fontsize: 0.9rem;\n$mobile-content-fontsize: 0.8rem;\n$text-darkgray: rgb(39, 32, 32);\n$text-shadow: #3d3d3d;\n$button-color: #2f7fb0;\n$button-color-hover: #0c4f76;\n$website-darkgray: rgb(44, 43, 43);\n$xeus-darkmaroon: #2f020c;\n$xeus-mediumbeige: rgb(224, 196, 154);\n$xeus-lightbeige: rgb(243, 226, 201);\n$website-border-lightgray: rgb(238, 234, 234);\n","@use \"./variables\" as *;\n\n@mixin tablet-and-desktop {\n    @media (min-width: $tablet-breakpoint) {\n        @content;\n    }\n}\n@mixin desktop {\n    @media (min-width: $desktop-breakpoint) {\n        @content;\n    }\n}\n\n@mixin big-mobile-screen {\n    @media (min-width: 450px) {\n        @content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
